import { render } from "./ChatSuggestion.vue?vue&type=template&id=04b3645e&scoped=true"
import script from "./ChatSuggestion.vue?vue&type=script&lang=js"
export * from "./ChatSuggestion.vue?vue&type=script&lang=js"

import "./ChatSuggestion.vue?vue&type=style&index=0&id=04b3645e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b3645e"]])

export default __exports__